// -----------------------------------------------
// tracking.js
// 必要な媒体のベースタグだけを条件分岐で挿入するモジュール
// -----------------------------------------------

const RULES = [
  {
    name: "tiktok_base_000538",
    enabled: true,
    pattern: /(?:^\?|&)company_cd=000538(?:&|$)/,
    inject: injectTikTokBase,
  },
  {
    // 2608_UCプラチナカード_①SEM経由サイト来訪(Meta)
    name: "meta_sem_visit_base_000536_000534",
    enabled: true,
    pattern: /(?:^\?|&)company_cd=(000536|000534)(?:&|$)/,
    inject: injectMetaSemVisitBase,
  },
  {
    // 2608_UCプラチナカード_②申し込みボタン押下(Meta)
    name: "meta_apply_click_base_000541",
    enabled: true,
    pattern: /(?:^\?|&)company_cd=000541(?:&|$)/,
    inject: injectMetaApplyClickBase,
  },
  {
    // 2608_UCプラチナカード_①SEM経由サイト来訪(TikTok)
    name: "tiktok_sem_visit_base_000536_000534",
    enabled: true,
    pattern: /(?:^\?|&)company_cd=(000536|000534)(?:&|$)/,
    inject: injectTikTokSemVisitBase,
  },
  {
    // 2608_UCプラチナカード_②申し込みボタン押下(TikTok)
    name: "tiktok_apply_click_base_000538",
    enabled: true,
    pattern: /(?:^\?|&)company_cd=000538(?:&|$)/,
    inject: injectTikTokApplyClickBase,
  },
  // 追加例:
  // {
  //   name: "media_name",
  //   enabled: true,
  //   pattern: /(?:^\?|&)company_cd=000000(?:&|$)/,
  //   inject: injectMediaBase,
  // },
];

function init() {
  const q = window.location.search || "";

  RULES.forEach((rule) => {
    if (!rule.enabled) return;
    if (!rule.pattern.test(q)) return;
    rule.inject();
  });
}

function injectTikTokBase() {
  injectTikTokBasePixel("D2K2V93C77U067DPRPC0", "tiktok-base");
}

function injectTikTokSemVisitBase() {
  injectTikTokBasePixel("DA1AT3JC77U7HHC74EHG", "tiktok-sem-visit-base");
}

function injectTikTokApplyClickBase() {
  injectTikTokBasePixel("DA226UBC77UAAA42TOI0", "tiktok-apply-click-base");
}

// TikTokベースピクセルを <!-- TikTok Pixel Code --> コメント付きでbody先頭に挿入する共通処理
function injectTikTokBasePixel(pixelId, dataAttr) {
  // すでにロード済みの場合は二重挿入しない
  if (document.querySelector(`script[data-tracking="${dataAttr}"]`)) return;

  const code = `
!function (w, d, t) {
  w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script");n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
  ttq.load("${pixelId}");
  ttq.page();
}(window, document, "ttq");
`;

  const script = document.createElement("script");
  script.setAttribute("data-tracking", dataAttr);
  script.textContent = code;

  const nodes = [
    document.createComment(" TikTok Pixel Code Start "),
    script,
    document.createComment(" TikTok Pixel Code End "),
  ];

  const insertNodes = (parent, before) => {
    nodes.forEach((node) => parent.insertBefore(node, before));
  };

  if (document.body && document.body.firstChild) {
    insertNodes(document.body, document.body.firstChild);
  } else if (document.body) {
    nodes.forEach((node) => document.body.appendChild(node));
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      if (document.body && document.body.firstChild) {
        insertNodes(document.body, document.body.firstChild);
      } else if (document.body) {
        nodes.forEach((node) => document.body.appendChild(node));
      }
    }, { once: true });
  }
}

function injectMetaSemVisitBase() {
  injectMetaBasePixel("1757453245399849", "meta-sem-visit-base");
}

function injectMetaApplyClickBase() {
  injectMetaBasePixel("1528610681871904", "meta-apply-click-base");
}

// Metaベースピクセルを <!-- Meta Pixel Code --> コメント付きでbody先頭に挿入する共通処理
function injectMetaBasePixel(pixelId, dataAttr) {
  // すでにロード済みの場合は二重挿入しない
  if (document.querySelector(`script[data-tracking="${dataAttr}"]`)) return;

  const code = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${pixelId}');
fbq('trackSingle', '${pixelId}', 'PageView');
`;

  const script = document.createElement("script");
  script.setAttribute("data-tracking", dataAttr);
  script.textContent = code;

  const nodes = [
    document.createComment(" Meta Pixel Code "),
    script,
    document.createComment(" End Meta Pixel Code "),
  ];

  const insertNodes = (parent, before) => {
    nodes.forEach((node) => parent.insertBefore(node, before));
  };

  if (document.body && document.body.firstChild) {
    insertNodes(document.body, document.body.firstChild);
  } else if (document.body) {
    nodes.forEach((node) => document.body.appendChild(node));
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      if (document.body && document.body.firstChild) {
        insertNodes(document.body, document.body.firstChild);
      } else if (document.body) {
        nodes.forEach((node) => document.body.appendChild(node));
      }
    }, { once: true });
  }
}

export default {
  init,
};
